import { render, staticRenderFns } from "./InfoLegale.vue?vue&type=template&id=b25426fa&scoped=true"
import script from "./InfoLegale.vue?vue&type=script&lang=js"
export * from "./InfoLegale.vue?vue&type=script&lang=js"
import style0 from "./InfoLegale.vue?vue&type=style&index=0&id=b25426fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25426fa",
  null
  
)

export default component.exports